<template>
    <div class="inline-vimeo-wrapper">
        <div class="inline-vimeo-inner" ref="inner">
            <img :src="json.hip.image" />
            <iframe :data-src="json.src" class="" frameborder="0"></iframe>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
    props: {
        json: {
            type: Object,
            required: true,
        },
        scrollTrigger: {
            type: Boolean,
            default: true,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
    },

    watch: {
        isActive: function (newVal) {
            if (!this.player) {
                console.log('Setup player');
                this.setupPlayer();
            }

            if (newVal) {
                this.player.play();
                return;
            }

            this.player.pause();
        },
    },

    data() {
        return {
            iframe: null,
        };
    },

    /**
     * Mount this stuff.
     */
    mounted() {
        this.iframe = this.json.code;

        this.$refs.inner.style.paddingBottom =
            (this.json.hip.height / this.json.hip.width) * 100 + '%';

        gsap.delayedCall(0, this.init);
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        init() {
            Vue.nextTick(() => {
                if (!this.player) {
                    this.setupPlayer();
                }

                if (this.isActive) {
                    this.player.play();
                } else {
                    this.player.pause();
                }
            });
        },

        setupPlayer() {
            const iframe = this.$el.querySelector('iframe');
            iframe.src = iframe.getAttribute('data-src');

            this.player = new Vimeo.Player(iframe);
            this.iframe = iframe;

            gsap.set(this.iframe, {
                autoAlpha: 0,
            });

            this.firstPlay = true;

            this.player.on('play', () => {
                console.log('play');
                gsap.set(this.iframe, {
                    autoAlpha: 1,
                    delay: this.firstPlay ? 1 : 0,
                });

                this.firstPlay = false;
            });
        },
    },
};
</script>
